import { observable, action } from 'mobx';
import ILookup from '../../types/ILookup';
import IConfiguration from "../../types/IConfiguration";
import IConfigurationService from "../../services/spi/IConfigurationService";
import ISettingsService from '../../services/spi/ISettingsService';
import FirebaseConfigurationService from "../../services/impl/firebase/FirebaseConfigurationService";
import FirebaseSettingsService from '../../services/impl/firebase/FirebaseSettingService';

class GeneralStore {
  rootStore: any = null;
  configurationService = {} as IConfigurationService;
  lookupService = {} as ISettingsService;
  @observable languages = [] as Array<ILookup>
  @observable brandText = {} as IConfiguration;
  @observable brandImage = {} as IConfiguration;
  @observable language = {} as IConfiguration;
  @observable dateTimeFormat = {} as IConfiguration;
  @observable timezone =  {} as IConfiguration;

  constructor(rootStore: any) {
    this.rootStore = rootStore;
    this.configurationService = new FirebaseConfigurationService();
    this.lookupService = new FirebaseSettingsService();
  }

  @action getGeneralSettings = async () => {
    this.brandText = await this.configurationService.getConfiguration("BRAND-TEXT");
    this.brandImage = await this.configurationService.getConfiguration("BRAND-LOGO-URL");
    this.language = await this.configurationService.getConfiguration("LANGUAGE");
    this.dateTimeFormat = await this.configurationService.getConfiguration("DATE-TIME-FORMAT");
    this.timezone = await this.configurationService.getConfiguration("TIMEZONE");
    this.languages = await this.lookupService.getLookupForType("LANGUAGES")
  }

}

export default GeneralStore;
